<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs :items="[{ text: $t('vehicles.vehicles'), name: 'company_vehicles' }, { text: vehicle.name }]" />
      </template>
      <template v-slot:meta>
        <button
          @click="deleteVehicle"
          :disabled="!vehicle.can_be_deleted"
          :title="deleteButtonText(vehicle)"
          class="button button-red button-small button-round"
        >
          {{ $t('vehicles.deleteVehicle') }}
        </button>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <BaseData :templateMode="'edit'" :value="vehicle" @submit="updateVehicle" />

        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('vehicles.chambers') }}</h3>
            <div class="header-meta">
              <p>
                <Link
                  :to="`/company/vehicles/${this.$route.params.vehicle_uuid}/chambers/new`"
                  class="button button-green button-small button-round"
                  >{{ $t('vehicles.addChamber') }}</Link
                >
              </p>
            </div>
          </header>
          <div class="content-body">
            <div v-if="vehicle.chambers">
              <div v-if="vehicle.chambers.length == 0" class="alert alert-danger">{{ $t('vehicles.noChambers') }}</div>
              <Table v-else>
                <template #header>
                  <th>{{ $t('meta.name') }}</th>
                  <th>{{ $t('chambers.fraction') }}</th>
                  <th>{{ $t('vehicles.capacity') }}</th>
                  <th class="table__th-actions">{{ $t('meta.actions') }}</th>
                </template>
                <template #body>
                  <tr v-for="chamber in vehicle.chambers" :key="chamber.uuid">
                    <td>{{ chamber.name }}</td>
                    <td>{{ chamber.fraction.name }}</td>
                    <td>{{ chamber.capacity }}</td>
                    <td class="table__actions">
                      <Link :to="`/company/vehicles/${vehicle.uuid}/chambers/${chamber.uuid}`">
                        <span class="material-icons">edit</span>
                      </Link>
                      <button @click="deleteChamber(chamber)" class="table__action-button">
                        <span class="material-icons">delete</span>
                      </button>
                    </td>
                  </tr>
                </template>
              </Table>
            </div>
          </div>
        </div>

        <History :history="history" @getVersionsData="getVersions" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseData from '@/views/companies/vehicles/BaseData'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import History from '@/components/History.vue'
import SectionHeader from '@/components/SectionHeader'
import Table from '@/components/Table'
import CompanyNav from '@/components/company_nav'

import categoryValuesApi from '@/api/categoryValues'
import vehiclesApi from '@/api/vehicles'

export default {
  name: 'ShowCompanyVehicle',
  inject: ['showPopup'],
  data() {
    return {
      vehicle: {},
      history: {
        versions: [],
        pagination: {
          page: 1,
          totalObjects: 0,
          perPage: 0,
        },
      },
      vehicleGroupValues: [],
    }
  },
  components: {
    BaseData,
    BreadCrumbs,
    CompanyNav,
    History,
    SectionHeader,
    Table,
  },
  computed: {
    vehicleGroupOptions() {
      return this.vehicleGroupValues.map(option => {
        return {
          value: option.name,
          label: option.localized_text,
        }
      })
    },
  },
  methods: {
    async getCategoryValues(context, category) {
      const result = await categoryValuesApi.get(context, category)

      if (context === 'vehicles' && category === 'vehicle_group') {
        this.vehicleGroupValues = result.sort((a, b) => {
          if (a.name === 'other' || b.name === 'other') {
            return 1
          } else {
            return a.text.toLowerCase() >= b.text.toLowerCase()
          }
        })
      }
    },
    async getVehicleData() {
      this.vehicle = await vehiclesApi.get(this.$route.params.vehicle_uuid)
    },
    async getVersions(page) {
      const currentPage = page || this.history.pagination.page
      const result = await vehiclesApi.getVersions(this.$route.params.vehicle_uuid, { page: currentPage })
      this.history.versions = result.versions
      this.history.pagination.totalObjects = result.pagination.total_objects
      this.history.pagination.perPage = result.pagination.per_page
    },
    updateVehicle: async function (vehicle) {
      const result = await vehiclesApi.update(this.$route.params.vehicle_uuid, vehicle)
      if (result.success) {
        this.vehicle = result.data.vehicle
      }
    },
    async deleteChamber(chamber) {
      const confirmAlert = await this.showPopup({
        content: this.$t('vehicles.chamberDeleteConfirmation'),
        type: 'confirm',
      })
      if (!confirmAlert) return

      await vehiclesApi.chambers.delete(this.vehicle.uuid, chamber.uuid)
      await this.getVehicleData()
      await this.getVersions(1)
    },
    async deleteVehicle() {
      const confirmAlert = await this.showPopup({
        content: this.$t('vehicles.vehicleDeleteConfirmation'),
        type: 'confirm',
      })
      if (!confirmAlert) return null

      const result = await vehiclesApi.delete(this.vehicle.uuid)
      // const notify = (noteType, text) =>
      //   this.$notify({
      //     group: 'alert',
      //     type: noteType,
      //     text: text,
      //   })

      if (result.success) {
        // notify('success', this.$t('containers.deleted'))
        this.$router.push({ name: 'company_vehicles' })
      }
    },
    deleteButtonText(vehicle) {
      if (!vehicle.can_be_deleted) {
        return this.$t('vehicles.cannotBeDeleted')
      }
    },
  },
  async mounted() {
    await Promise.all([this.getVehicleData(), this.getVersions(1), this.getCategoryValues('vehicles', 'vehicle_group')])
  },
}
</script>
